import Button from '@/common/components/Button'
import { CopyButton } from '@/common/components/CopyButton'
import { useCopyButton } from '@/common/hooks/useCopyButton'
import { EstablishmentCompanyData } from '@/common/types/establishment/company.type'
import { formatDate } from '@/common/utils/formatters'
import Skeleton from '../Skeleton'

interface SubdomainSectionProps {
  url?: string
  establishmentCompany?: EstablishmentCompanyData
  establishmentCompanyIsPending?: boolean
}

export const SubdomainSection = ({ url, establishmentCompany, establishmentCompanyIsPending }: SubdomainSectionProps) => {
  const { control, copySuccess } = useCopyButton()

  return (
    <div className="flex items-center gap-2 w-full">
      {(url || establishmentCompanyIsPending) && (
        <div className="w-full bg-white-200 rounded-lg p-4 space-y-2">
          <p className="text-[11px] leading-3">
            Subdomínio
          </p>

          <div className="flex items-center gap-2">
            {establishmentCompanyIsPending ? (
              <Skeleton />
            ) : (
              <p className="text-sm">
                {url}
              </p>
            )}

            <Button variant="link-white" disabled={!url} onClick={() => url && copySuccess(url)}>
              <CopyButton control={control} className="size-4" />
            </Button>
          </div>
        </div>
      )}

      <div className="w-full bg-white-200 rounded-lg p-4 space-y-2 self-stretch">
        <p className="text-[11px] leading-3">
          Data de inclusão
        </p>

        <p className="text-sm">
          {establishmentCompanyIsPending
            ? <Skeleton className='w-20' />
            : establishmentCompany?.matrix_branch?.created_at && formatDate(new Date(establishmentCompany?.matrix_branch?.created_at))}
        </p>
      </div>
    </div>
  )
}
